import { Moment } from "moment";

import { renderMultiSectionDigitalClockTimeView } from "@mui/x-date-pickers/timeViewRenderers";
import { multiSectionDigitalClockSectionClasses } from "@mui/x-date-pickers/MultiSectionDigitalClock";
import { DateTimePickerProps } from "@mui/x-date-pickers/DateTimePicker";

// The default MultiSectionDigitalClock renders fixed 56px-wide columns
// inside the 320px picker, leaving a large empty band on the right
// (worst for 24-hour operators, where only hours + minutes render).
// Stretch the columns and their items to share the full picker width.
const multiSectionClockSx = {
  [`& .${multiSectionDigitalClockSectionClasses.root}`]: {
    flex: 1,
    width: "auto",
    scrollbarGutter: "stable",
    scrollbarWidth: "thin",
    scrollbarColor: "rgba(0, 0, 0, 0.4) transparent",
    "&::-webkit-scrollbar": {
      width: 6,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0, 0, 0, 0.4)",
      borderRadius: 999,
    },
  },
  [`& .${multiSectionDigitalClockSectionClasses.item}`]: {
    width: "auto",
  },
};

const renderStretchedClockTimeView: typeof renderMultiSectionDigitalClockTimeView =
  (props) =>
    renderMultiSectionDigitalClockTimeView({
      ...props,
      sx: props.sx
        ? [
            multiSectionClockSx,
            ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
          ]
        : multiSectionClockSx,
    });

// MUI v6 types DateTimePicker's `viewRenderers` against the analog clock
// renderer's props, which don't unify with the multi-section digital clock
// renderer's, even though the picker forwards compatible props at runtime
// (this renderer is MUI's own desktop default).
export const dateTimeViewRenderers = {
  hours: renderStretchedClockTimeView,
  minutes: renderStretchedClockTimeView,
  seconds: renderStretchedClockTimeView,
  meridiem: renderStretchedClockTimeView,
} as unknown as DateTimePickerProps<Moment>["viewRenderers"];
